import { render, staticRenderFns } from "./plano.vue?vue&type=template&id=5d66690a&scoped=true"
import script from "./plano.vue?vue&type=script&lang=js"
export * from "./plano.vue?vue&type=script&lang=js"
import style0 from "./plano.vue?vue&type=style&index=0&id=5d66690a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66690a",
  null
  
)

export default component.exports